export const yieldToMain = () => {
    return new Promise(resolve => {
        window.setTimeout(resolve, 0);
    });
};

export const scheduleIdle = (cb) => {
    (window.requestIdleCallback || window.setTimeout)(cb);
};
